import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { storageService, UserLogin } from "../../api";

const AuthTokenService = (onAuthChange?: (isLoggedIn: boolean) => void) => {
    const [currentQueryParameters, setSearchParams] = useSearchParams();
    const idmResponse = currentQueryParameters.get("idmresponse");

    const setToken = useCallback(
        (profile: UserLogin) => {
            storageService.setProfile(profile);
            onAuthChange?.(true); // Notify parent of login status
        },
        [onAuthChange]
    );
    const clearToken = useCallback(() => {
        storageService.clearToken();
        onAuthChange?.(false); // Notify parent of logout
    }, [onAuthChange]);

    const parseJwt = useCallback((token: string) => {
        const base64Url = token.split(".")?.[1];
        if (!base64Url) return;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    }, []);
    const isLoggedIn = useCallback(() => {
        const token = storageService.getToken();
        if (!token || idmResponse) return false;

        const tokenExp = parseJwt(token)?.exp ?? 0;
        const current_time = new Date().getTime() / 1000;
        const expired = tokenExp - 60 * 60 * 24 < current_time;
        if (expired) clearToken();

        return !expired;
    }, [parseJwt, clearToken, idmResponse]);

    const handleStorageChange = useCallback(
        (event: any) => {
            onAuthChange?.(false);
        },
        [onAuthChange]
    );

    useEffect(() => {
        window.addEventListener("authTokenCleared", handleStorageChange);

        return () => {
            window.removeEventListener("authTokenCleared", handleStorageChange);
        };
    }, [handleStorageChange]);

    return {
        setToken,
        clearToken,
        isLoggedIn
    };
};
export default AuthTokenService;
